// extracted by mini-css-extract-plugin
export default {"wrapper":"coverage-checker-module--wrapper--e2a58","coverageParagraph":"coverage-checker-module--coverage-paragraph--e54d6"};